import { useState, useEffect } from "react";

const MensajePanel = () => {
  const STORAGE_KEY = "MensajePanel";
  const [isVisible, setIsVisible] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) !== "true";
  });

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem(STORAGE_KEY, "true");
  };

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === "true") {
      setIsVisible(false);
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="mensaje-panel-warning">
      <button onClick={handleClose}>
        X
      </button>
      <p>Aviso global: Para optimizar la gestión de los tickets, los tickets no respondidos en un plazo máximo de 3 días, serán cerrados automáticamente.</p>
    </div>
  );
};

export default MensajePanel;
